import React from 'react';
import { Carousel } from 'react-bootstrap';
import Slider2 from './Images/Slider 2.jpg'
import ii from './Images/ii.jpg'
import Slider1 from './Images/slider1.jpg'
import './Slider.css'

const Slider = () => {
  return (
    <div>
      <Carousel>
  <Carousel.Item>
    <img
      className="d-block w-100 img-fluid"
      src={ii}
      alt="First slide"
    />
    <Carousel.Caption className='bg-black w-50 rounded m-auto'>
      <h3 className='text-info'>First Project</h3>
      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100 img-fluid"
      src={Slider2} 
      alt="Second slide"
    />

    <Carousel.Caption className='bg-black w-50 rounded m-auto'>
      <h3 className='text-info'>Second slide label</h3>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100 img-fluid"
      src={Slider1}
      alt="Third slide"
    />

    <Carousel.Caption className='bg-black w-50 rounded m-auto'>
      <h3 className='text-info'>Third slide label</h3>
      <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
    </Carousel.Caption>
  </Carousel.Item>
</Carousel>
    </div>
  );
};

export default Slider;